import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { FaUsers, FaTrash } from "react-icons/fa";
import RandomColorCircle from "../utils/RandomColorCircle";
import EmailShareList from "../utils/EmailShareList";

/**
 * ShareModal - Reusable modal for sharing a scheda with other users.
 * Visual design follows the Stitch "Modifica Scheda Spese" reference screen
 * (icon header, card-style collaborator rows, pill role select + footer actions).
 */
export const ASSIGNABLE_ROLES = ["Admin", "Editor", "Watcher"];

const SHARE_FORM_ID = "share-scheda-form";

const ShareModal = ({
  show,
  onHide,
  scheda,
  user,
  // Share form props
  utentiList,
  isFormModified,
  onAddEmail,
  onValidateEmail,
  onRemoveEmail,
  onRemoveSharedUser,
  onChangeUserRole,
  getPendingRole,
  onSubmit,
  onClose,
}) => {
  const canManageUsers = !!scheda.myPermissions?.canAggiungereUtente;
  const schedaUtentiList = scheda.utentiList || [];

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      contentClassName="share-modal-content"
    >
      <Modal.Header closeButton className="share-modal-header">
        <div className="d-flex align-items-center gap-3">
          <div className="share-modal-icon">
            <FaUsers size={18} />
          </div>
          <div>
            <Modal.Title className="share-modal-title">
              Share "{scheda.titolo}"
            </Modal.Title>
            <p className="share-modal-subtitle mb-0">
              Manage collaborators and permission access.
            </p>
          </div>
        </div>
      </Modal.Header>

      <Modal.Body className="share-modal-body">
        <Form id={SHARE_FORM_ID} onSubmit={onSubmit}>
          <EmailShareList
            emailList_tmp={utentiList}
            onAddEmail={onAddEmail}
            onValidateEmail={onValidateEmail}
            onRemoveEmail={onRemoveEmail}
            emailListParent={schedaUtentiList}
          />
        </Form>

        <div className="share-modal-section-title mt-4 mb-3">
          <FaUsers size={14} />
          <h3 className="mb-0">Shared users</h3>
          {/* <span className="share-modal-count">{schedaUtentiList.length}</span> */}
        </div>

        <div className="d-flex flex-column gap-2">
          {schedaUtentiList.map((userMail) => {
            const isEditable =
              userMail.role !== "Owner" &&
              canManageUsers &&
              user.email !== userMail.email;

            return (
              <div className="share-collab-card" key={userMail._id}>
                <div className="d-flex align-items-center gap-3" style={{ minWidth: 0 }}>
                  <RandomColorCircle
                    letter={userMail.email[0]}
                    tooltip={userMail.email}
                    email={userMail.email}
                  />
                  <div style={{ minWidth: 0 }}>
                    <p className="share-collab-name mb-0 text-truncate">
                      {userMail.email}
                      {user.email === userMail.email && (
                        <span className="share-collab-you">You</span>
                      )}
                    </p>
                    {!isEditable && (
                      <p className="share-collab-role-text mb-0">
                        {userMail.role}
                      </p>
                    )}
                  </div>
                </div>

                {isEditable && (
                  <div className="d-flex align-items-center gap-2 flex-shrink-0">
                    <Form.Select
                      className="share-role-select"
                      aria-label="role"
                      value={getPendingRole?.(userMail._id) ?? userMail.role}
                      onChange={(e) => onChangeUserRole(userMail, e.target.value)}
                    >
                      {ASSIGNABLE_ROLES.map((role) => (
                        <option key={role} value={role}>
                          {role}
                        </option>
                      ))}
                    </Form.Select>
                    <button
                      type="button"
                      className="share-collab-remove-btn"
                      onClick={() => onRemoveSharedUser(userMail)}
                      aria-label={`Remove ${userMail.email}`}
                    >
                      <FaTrash size={12} />
                    </button>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </Modal.Body>

      <Modal.Footer className="share-modal-footer">
        <button
          type="button"
          className="dashboard-btn-secondary"
          onClick={onClose}
        >
          Cancel
        </button>
        <button
          type="submit"
          form={SHARE_FORM_ID}
          className="dashboard-btn-primary"
          disabled={!isFormModified}
        >
          Save Changes
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ShareModal;
